export default {
  data: () => ({
    eventListeners: []
  }),
  mounted() {
    this.eventListeners.forEach(item => {
      this.$eventHub.$on(item.name, item.callback);
    });
  },
  beforeDestroy() {
    this.eventListeners.forEach(item => {
      this.$eventHub.$off(item.name);
    });
  }
};
